/**
 * Defers custom.js (Swiper + CountUp, no jQuery) until needed.
 * Starts on: whenThemeVendorsReady waiters, near [data-needs-theme-vendors],
 * first interaction, or idle after load.
 */
(function () {
  var queue = [];
  var loading = null;
  var started = false;

  function flushQueue() {
    var pending = queue.splice(0, queue.length);
    pending.forEach(function (callback) {
      try {
        callback();
      } catch (error) {
        console.error(error);
      }
    });
  }

  function loadVendors() {
    if (typeof window.Swiper === 'function') {
      flushQueue();
      return Promise.resolve();
    }

    if (loading) return loading;

    var url = window.themeVendorScriptUrl;
    if (!url) {
      return Promise.reject(new Error('themeVendorScriptUrl missing'));
    }

    loading = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.dataset.themeVendors = 'true';
      script.onload = function () {
        document.dispatchEvent(new CustomEvent('theme:vendors:ready'));
        flushQueue();
        resolve();
      };
      script.onerror = function () {
        loading = null;
        reject(new Error('Failed to load theme vendors'));
      };
      document.head.appendChild(script);
    });

    return loading;
  }

  function startVendorLoad() {
    if (started) return loading;
    started = true;
    return loadVendors();
  }

  window.ensureThemeVendors = startVendorLoad;

  window.whenThemeVendorsReady = function (callback) {
    if (typeof callback !== 'function') return;
    if (typeof window.Swiper === 'function') {
      callback();
      return;
    }
    queue.push(callback);
    startVendorLoad();
  };

  function observeVendorSections() {
    var nodes = document.querySelectorAll('[data-needs-theme-vendors]');

    if ('IntersectionObserver' in window && nodes.length) {
      var observer = new IntersectionObserver(
        function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) {
            startVendorLoad();
            observer.disconnect();
          }
        },
        { rootMargin: '500px 0px' }
      );
      nodes.forEach(function (node) {
        observer.observe(node);
      });
    }

    window.addEventListener('load', function () {
      var schedule = window.requestIdleCallback || function (cb, opts) {
        setTimeout(cb, (opts && opts.timeout) || 1);
      };
      schedule(function () {
        startVendorLoad();
      }, { timeout: 4000 });
    });
  }

  ['touchstart', 'scroll', 'keydown', 'pointerdown'].forEach(function (eventName) {
    window.addEventListener(eventName, startVendorLoad, { once: true, passive: true });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeVendorSections);
  } else {
    observeVendorSections();
  }
})();
